import React, { useEffect, useState } from "react";
import "./Style.css";
import PropTypes from "prop-types";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import emptyfile from "../../../../Assets/emptyfile.svg";
import InfiniteScroll from "react-infinite-scroll-component";
import sortingimg from "../../../../Assets/sortingarrow.svg";
function Row({ row }) {


  const getColor = (aiScore) => {
    if (aiScore > 80) {
      return "green";
    } else if (aiScore >= 50 && aiScore <= 80) {
      return "yellow";
    } else {
      return "red";
    }
  };
  const color = getColor(row.ai_score);
  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell align="left">
          <h3 className="company-name-country">
            {row?.name ? row?.name : "-"}
          </h3>
          <p className="after-company-name-country">
            {row?.location_identifiers ? row?.location_identifiers : "-"}
          </p>
        </TableCell>
        <TableCell>
          <div className="ai-score-background-main">
            <div
              className="ai-score-background"
              style={{
                background:
                  color === "red"
                    ? "#DA291C"
                    : color === "yellow"
                    ? "#EAB121"
                    : color === "green"
                    ? "#0EB93E"
                    : null,
              }}
            >
              {row?.ai_score !== null && row?.ai_score !== undefined
                ? row?.ai_score
                : "NA"}
            </div>
          </div>
        </TableCell>
        <TableCell align="left">
          <p className="employee-count">
            {row?.num_employees ? row?.num_employees : "-"}{" "}
          </p>
        </TableCell>
        <TableCell align="left">
          <p className="employee-count">
            {row?.revenue_range ? row?.revenue_range : "-"}
          </p>
        </TableCell>
        <TableCell align="left">
          <p className="employee-count">
            {row?.people_count ? row?.people_count : "-"}
          </p>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}
Row.propTypes = {
  row: PropTypes.object.isRequired,
};
export default function DetailsTable({
  tableShowResult,
  resultRetrieve,
  hasMore,
  fetchMoreData,
  totalPages,
  skip,
  setSkip,
  dataCount,
  showingResult,
  newShowingResult,
  totalRecords,
}) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortField, setSortField] = useState(null);
  const loadMore = () => {
    setLoading(true);
    setSkip((page) => page + 1);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };
  useEffect(() => {
    setData(resultRetrieve);
  }, [resultRetrieve]);
  
  // Function to normalize num_employees values (e.g., "1k-5k" → "1001-5000")
  const parseEmployeeSize = (size) => {
    const mapping = {
      "1k-5k": "1001-5000",
      "5k-10k": "5001-10000",
      "10k+": "10000+",
      "1K-5K": "1001-5000",
      "5K-10K": "5001-10000",
      "10K+": "10000+",
    };
  
    const normalizedSize = mapping[size] || size; // Convert shorthand to standard format
    const [min, max] = normalizedSize?.split("-").map((v) => 
      v.toLowerCase().includes("k") || v.toLowerCase().includes("m") 
        ? parseInt(v.replace("k", "000").replace("m", "000000")) 
        : parseInt(v)
    );
  
    return { min: min || 0, max: max || Infinity, original: size };
  };

  const sortData = (field) => {
    const newSortOrder = sortOrder === "asc" ? "desc" : "asc";

    const sorted = [...data].sort((a, b) => {
      const sizeA = parseEmployeeSize(a.num_employees);
      const sizeB = parseEmployeeSize(b.num_employees);
      return (sizeA.min - sizeB.min) * (newSortOrder === "asc" ? 1 : -1);
    });
    
    setSortOrder(newSortOrder);
    setSortField(field);
    setData(sorted);
  };
  // const handleSort = (field) => {
  //   const newSortOrder = sortOrder === "asc" ? "desc" : "asc";
  //   setSortOrder(newSortOrder);
  //   setSortField(field);
  //   const sortedData = [...data].sort((a, b) => {
  //     if (typeof a[field] === "number" && typeof b[field] === "number") {
  //       if (a[field] === b[field]) return a.name.localeCompare(b.name);
  //       return newSortOrder === "asc"
  //         ? a[field] - b[field]
  //         : b[field] - a[field];
  //     }
  //     if (typeof a[field] === "string" && typeof b[field] === "string") {
  //       return newSortOrder === "asc"
  //         ? a[field].localeCompare(b[field])
  //         : b[field].localeCompare(a[field]);
  //     }
  //     return 0;
  //   });
  //   setData(sortedData);
  // };


  const handleSort = (field) => {
    let newSortOrder;
    if (sortField === field) {
      newSortOrder = sortOrder === "asc" ? "desc" : "asc";
    } else {
      newSortOrder = "asc";
    }
    setSortOrder(newSortOrder);
    setSortField(field);

    const employeeOrder = [
      "1-10", "11-50", "51-100", "101-250", "251-500", "501-1000",
      "1K-5K", "5K-10K", "1k-10k" , "10K+"
    ];

    const revenueOrder = [
      "$0-$1m", "$0-$1M", "$1m-$10m", "$1M-$10M", "$10m-$50m", "$10M-$50M", "$50m-$100m", "$50M-$100M",
      , "$100m-$500m", "$100M-$500M", "$500m-$1b", "$500M-$1B", "$1b-$10b", "$1B-$10B", "$10b+", "$10B+"
    ];

    const getOrderIndex = (value, orderArray) => {
      const index = orderArray.indexOf(value);
      return index !== -1 ? index : orderArray.length;
    };

    const sortedData = [...data].sort((a, b) => {
      let aValue = field.includes(".")
        ? field.split(".").reduce((acc, key) => acc?.[key], a)
        : a[field];
      let bValue = field.includes(".")
        ? field.split(".").reduce((acc, key) => acc?.[key], b)
        : b[field];

      const isEmpty = (val) => val === null || val === "" || val === "-";
      const aIsEmpty = isEmpty(aValue);
      const bIsEmpty = isEmpty(bValue);

      if (aIsEmpty && !bIsEmpty) return 1;
      if (!aIsEmpty && bIsEmpty) return -1;
      if (aIsEmpty && bIsEmpty) return 0;

      if (field === "updated_at") {
        aValue = new Date(aValue);
        bValue = new Date(bValue);
      }

      if (field === "num_employees") {
        return newSortOrder === "asc"
          ? getOrderIndex(aValue, employeeOrder) - getOrderIndex(bValue, employeeOrder)
          : getOrderIndex(bValue, employeeOrder) - getOrderIndex(aValue, employeeOrder);
      }

      if (field === "revenue_range") {
        return newSortOrder === "asc"
          ? getOrderIndex(aValue, revenueOrder) - getOrderIndex(bValue, revenueOrder)
          : getOrderIndex(bValue, revenueOrder) - getOrderIndex(aValue, revenueOrder);
      }

      if (typeof aValue === "number" && typeof bValue === "number") {
        return newSortOrder === "asc" ? aValue - bValue : bValue - aValue;
      }

      if (typeof aValue === "string" && typeof bValue === "string") {
        return newSortOrder === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      if (aValue instanceof Date && bValue instanceof Date) {
        return newSortOrder === "asc" ? aValue - bValue : bValue - aValue;
      }

      return 0;
    });

    setData(sortedData);
  };

  return (
    <div className="ai-profile-table-main">
      {resultRetrieve?.length ? (
        <>
          <div className="showing-table-rec">
            <p>Showing {totalRecords ? totalRecords : "0"} Records</p>
          </div>
          <TableContainer component={Paper} className="aiprofile-table-container">
            <Table aria-label="collapsible table" className="ai-leads-table">
              <TableHead>
                <TableRow className="table-row-ai-leads">
                  <TableCell align="left" className="company-row-table">
                    Organization & location{" "}
                    <img
                      src={sortingimg}
                      alt=""
                      onClick={() => handleSort("name")}
                      className="sorting-arrow-leadsprofile"
                    />
                  </TableCell>
                  <TableCell className="score-row-table">
                    JScore{" "}
                    <img
                      src={sortingimg}
                      alt=""
                      onClick={() => handleSort("ai_score")}
                      className="sorting-arrow-leadsprofile"
                    />
                  </TableCell>
                  <TableCell className="score-row-table">
                    Employee Size{" "}
                    <img
                      src={sortingimg}
                      alt=""
                      onClick={() => sortData("num_employees")}
                      className="sorting-arrow-leadsprofile"
                    />
                  </TableCell>
                  <TableCell className="score-row-table">
                    Annual Revenue{" "}
                    <img
                      src={sortingimg}
                      onClick={() => handleSort("revenue_range")}
                      alt=""
                      className="sorting-arrow-leadsprofile"
                    />
                  </TableCell>
                  <TableCell align="left" className="prospects-row-table">
                    Prospects{" "}
                    <img
                      src={sortingimg}
                      onClick={() => handleSort("people_count")}
                      alt=""
                      className="sorting-arrow-leadsprofile"
                    />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.map((row, index) => (
                  <Row key={index} row={row} />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {dataCount !== resultRetrieve?.length && (
            <div className="loadmore-pagination-section">
              <button
                className="btn-load-more button-loadmore-pagination"
                onClick={loadMore}
                disabled={loading}
              >
                {loading ? "Loading..." : "Load More"}
              </button>
            </div>
          )}
        </>
      ) : (
        <TableContainer component={Paper} className="aiprofile-table-container">
          <Table aria-label="collapsible table" className="ai-leads-table-empty">
            
            <TableBody>
              <TableRow>
              <TableCell className="tCell-table-outer-main">
                  <div className="empty-container-div-main">
                    <div className="icon-and-backgroundimage">
                      <div className="empty-icon-div"></div>
                      <div>
                        <img
                          src={emptyfile}
                          alt=""
                          className="empty-icon-image"
                        />
                      </div>
                    </div>
                    <p className="no-result-found-empty">No result for now</p>
                    <p className="add-filter-empty">
                    Please adjust filters to view results
                    </p>
                  </div>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );
}






















// import React, { useState } from "react";
// import "./Style.css";
// import PropTypes from "prop-types";
// import Table from "@mui/material/Table";
// import TableBody from "@mui/material/TableBody";
// import TableCell from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
// import TableRow from "@mui/material/TableRow";
// import Paper from "@mui/material/Paper";
// import emptyfile from "../../../../Assets/emptyfile.svg";
// import InfiniteScroll from "react-infinite-scroll-component";
// import sortingimg from "../../../../Assets/sortingarrow.svg"
// function Row({ row }) {
  
//   const getColor = (aiScore) => {
//     if (aiScore > 80) {
//       return "green";
//     } else if (aiScore >= 50 && aiScore <= 80) {
//       return "yellow";
//     } else {
//       return "red";
//     }
//   };
//   const color = getColor(row.ai_score);
//   return (
//     <React.Fragment>
//       <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
//         <TableCell align="left">
//           <h3 className="company-name-country">{row?.name ? row?.name : "-"}</h3>
//           <p className="after-company-name-country">{row?.location_identifiers ? row?.location_identifiers : "-"}</p>
//         </TableCell>
//         <TableCell component="th" scope="row" className="juihy">
//           <div className="ai-score-background-main">
//             <div
//               className="ai-score-background"
//               style={{
//                 background:
//                   color === "red"
//                     ? "#DA291C"
//                     : color === "yellow"
//                       ? "#EAB121"
//                       : color === "green"
//                         ? "#0EB93E"
//                         : null,
//               }}
//             >
//               {/* {row?.ai_score ? row?.ai_score : "-"} */}
//               {row?.ai_score !== null && row?.ai_score !== undefined
//                 ? row?.ai_score
//                 : "NA"}
//             </div>
//           </div>
//         </TableCell>
//         <TableCell align="left">
//           <p className="employee-count">{row?.num_employees ? row?.num_employees : "-"} </p>
//         </TableCell>
//         <TableCell align="left">
//           <p className="employee-count">{row?.revenue_range ? row?.revenue_range : "-"}</p>
//         </TableCell>

//         <TableCell align="left">
//           <p className="employee-count">{row?.people_count ? row?.people_count : "-"}</p>
//         </TableCell>
//       </TableRow>
//     </React.Fragment>
//   );
// }
// Row.propTypes = {
//   row: PropTypes.shape({
//     calories: PropTypes.number.isRequired,
//     carbs: PropTypes.number.isRequired,
//     fat: PropTypes.number.isRequired,
//     history: PropTypes.arrayOf(
//       PropTypes.shape({
//         amount: PropTypes.number.isRequired,
//         customerId: PropTypes.string.isRequired,
//         date: PropTypes.string.isRequired,
//       })
//     ).isRequired,
//     name: PropTypes.string.isRequired,
//     price: PropTypes.number.isRequired,
//     protein: PropTypes.number.isRequired,
//   }).isRequired,
//   selected: PropTypes.bool.isRequired,
//   onSelect: PropTypes.func.isRequired,
// };
// const rows = [1, 1, 1, 1, 1];
// export default function DetailsTable({ tableShowResult, resultRetrieve, hasMore, fetchMoreData, totalPages, skip, setSkip, dataCount, showingResult, newShowingResult,totalRecords }) {
  
//   const [loading, setLoading] = useState(false);
//   const loadMore = () => {
//     setLoading(true);
//     setSkip(page => page + 1);
//     setTimeout(() => {
//       setLoading(false);
//     }, 1000);
//   };
//   return (
//     <div className="ai-profile-table-main">
//       {resultRetrieve?.length ? (
//         <>
//           {/* <InfiniteScroll
//             dataLength={resultRetrieve?.length}
//             next={() => fetchMoreData()}
//             hasMore={hasMore}
//             scrollableTarget="aiprofile-table-container"
//           > */}
//           {/* <div className="showing-table-rec"><p>Showing {showingResult + newShowingResult || resultRetrieve.length} Records</p></div> */}
//           <div className="showing-table-rec"><p>Showing {totalRecords ? totalRecords:"0"} Records</p></div>
//           <TableContainer component={Paper} className="aiprofile-table-container">
//             <Table aria-label="collapsible table" className="ai-leads-table">
//               <TableHead>
//                 <TableRow className="table-row-ai-leads">
//                   <TableCell align="left" className="company-row-table">
//                   Organization & location <img src={sortingimg} alt="" className="sorting-arrow-leadsprofile" />
//                   </TableCell>
//                   <TableCell className="score-row-table">JScore <img src={sortingimg} alt="" className="sorting-arrow-leadsprofile"/></TableCell>
//                   <TableCell className="score-row-table">Employee Size <img src={sortingimg} alt="" className="sorting-arrow-leadsprofile"/></TableCell>
//                   <TableCell className="score-row-table">Annual Revenue <img src={sortingimg} alt="" className="sorting-arrow-leadsprofile"/></TableCell>
//                   <TableCell align="left" className="prospects-row-table">
//                     Prospects
//                   </TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {resultRetrieve?.map((row, index) => (
//                   <React.Fragment key={index}>
//                     <Row
//                       key={row.name}
//                       row={row}
//                     />
//                   </React.Fragment>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//           {
//             <div className="loadmore-pagination-section">
//               {dataCount !== resultRetrieve?.length && <button className="btn-load-more button-loadmore-pagination" onClick={loadMore} disabled={loading}>{loading ? 'Loading...' : 'Load More'}</button>}
//             </div>
//           }
//           {/* {
//             dataCount !== resultRetrieve?.length && (
//               <div className="loadmore-pagination-section">
//                 {totalPages !== skip && (
//                   <button
//                     className="btn-load-more button-loadmore-pagination"
//                     onClick={loadMore}
//                     disabled={loading}
//                   >
//                     {loading ? 'Loading...' : 'Load More'}
//                   </button>
//                 )}
//               </div>
//             )
//           } */}
//           {/* </InfiniteScroll> */}
//         </>
//       ) : (
//         <TableContainer component={Paper} className="aiprofile-table-container">
//           <Table
//             aria-label="collapsible table"
//             className="ai-leads-table-empty"
//           >
//             <TableHead>
//               <TableRow className="table-row-ai-leads"></TableRow>
//             </TableHead>
//             <TableBody>
//               <TableRow>
                // <TableCell className="tCell-table-outer-main">
                //   <div className="empty-container-div-main">
                //     <div className="icon-and-backgroundimage">
                //       <div className="empty-icon-div"></div>
                //       <div>
                //         <img
                //           src={emptyfile}
                //           alt=""
                //           className="empty-icon-image"
                //         />
                //       </div>
                //     </div>
                //     <p className="no-result-found-empty">No result for now</p>
                //     <p className="add-filter-empty">
                //     Please adjust filters to view results
                //     </p>
                //   </div>
                // </TableCell>
//               </TableRow>
//             </TableBody>
//           </Table>
//         </TableContainer>
//       )}
//     </div>
//   );
// }